import {versionController} from '../../../shared/scripts/EntryShared.ts'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables.ts'
import {ViewPopupLogin} from '../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts'
import {StorageWrapper} from '../../../shared/scripts/StorageWrapper.ts'
import {UserSessionUtils} from '../../../shared/scripts/UserSessionUtils.ts'
import {DurationConverter, RandomUtils, TimeUtils} from '@colonist/utils'
import {DiscordInstance} from '../discord/DiscordInstance.ts'
import {AnalyticEventValue} from '../../../../shared/entity_datas/EntityDatas.ts'
import {ViewPopupBecomeMemberGameplay} from '../../../shared/scripts/ui_popup/ViewPopupBecomeMemberGameplay.ts'
import {ViewPopupBecomeMemberBasic} from '../../../shared/scripts/ui_popup/ViewPopupBecomeMemberBasic.ts'
import {SDKRequest} from '../../../../shared/DiscordActivityTypes.ts'
import {ColonistMembershipType} from '@colonist/types'
import {navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils.ts'
import {UIEntryUrlParameterController} from '../../../shared/scripts/UIEntryUrlParameterController.ts'

export class UIPopupFunnelIncentiveController {
    private static showMembershipIncentivePopup(accessGameFromLink: boolean) {
        if(accessGameFromLink) return
        if(UIEntryUrlParameterController.suppressPopupsOnLoad == true) return
        const lastMembershipIncentivePopupTime = StorageWrapper.getLastMembershipIncentivePopupTime()
        if(UIPopupFunnelIncentiveController.membershipIncentivePopupWasShownInLastTwentyFourHours(lastMembershipIncentivePopupTime)) return

        const showGameplayPopup = UIUtilsEjsVariables.isUserOnDiscord || RandomUtils.randomBool()
        const analyticEventValue = UIUtilsEjsVariables.isUserOnDiscord ? AnalyticEventValue.PopupMembershipIncentiveDiscordGeneral : AnalyticEventValue.PopupMembershipIncentiveSubscription
        const checkAction = UIUtilsEjsVariables.isUserOnDiscord ? () => {
            void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseMembership, ColonistMembershipType.PremiumMonthly)
        } : () => {
            navigateToPage('/store#membership', true)
        }

        showGameplayPopup ? new ViewPopupBecomeMemberGameplay(checkAction, analyticEventValue, () => undefined, false) : new ViewPopupBecomeMemberBasic(checkAction, analyticEventValue, () => undefined, false)
        StorageWrapper.setLastMembershipIncentivePopupTime(new Date())
    }

    private static membershipIncentivePopupWasShownInLastTwentyFourHours(lastMembershipIncentivePopupTime: Date | null): boolean {
        if(lastMembershipIncentivePopupTime == null) return false
        const millisecondsSinceLastMembershipIncentivePopupTime = TimeUtils.millisecondsPassedSince(lastMembershipIncentivePopupTime.getTime())
        const shownWithinLastDay = millisecondsSinceLastMembershipIncentivePopupTime < DurationConverter.daysAsMilliseconds(1)
        return shownWithinLastDay
    }

    static showPopup(accessGameFromLink: boolean) {
        if(versionController?.willShowPatchnoteThisSession) return

        if(UIEntryUrlParameterController.suppressPopupsOnLoad == true) return
        if(UserSessionUtils.canShowLoginPopup()) new ViewPopupLogin(false, undefined)
        else if(UserSessionUtils.canShowSubscriptionPopup()) UIPopupFunnelIncentiveController.showMembershipIncentivePopup(accessGameFromLink)
    }
}
